// src/components/ui/DataTable.jsx
//
// Standard responsive/sticky-header container for data tables across the
// admin + user areas (Giai đoạn 2 of the UI/UX upgrade plan). Replaces the
// per-page `calc-160/186/206/232/246/256` fixed-pixel height classes and
// ad hoc `data-loading` attribute from site_css.css with a real sticky
// header (CSS `position: sticky`) inside a height-bounded scroll region,
// plus consistent loading/empty states.
//
// Deliberately takes the actual <table> markup as `children` instead of a
// data-driven columns/rows API — every existing page already renders its
// own <thead>/<tbody>, and rewriting that row-by-row is out of scope for
// a shared wrapper. This only standardizes the container around it, so
// pages can adopt it incrementally in Giai đoạn 3 without rewriting their
// row rendering.
import React from "react";
import LoadingState from "./LoadingState";
import EmptyState from "./EmptyState";
import "./dataTable.css";

const DataTable = ({
  children,
  loading = false,
  empty = false,
  emptyMessage = "Không có dữ liệu",
  maxHeight = "70vh",
  stickyHeader = true,
  className = "",
  ...rest
}) => {
  return (
    <div
      className={`zto-data-table ${stickyHeader ? "zto-data-table--sticky" : ""} ${className}`}
      style={{ "--zto-data-table-max-height": maxHeight }}
      {...rest}
    >
      {loading ? (
        <LoadingState />
      ) : empty ? (
        <EmptyState message={emptyMessage} />
      ) : (
        <div className="zto-data-table__scroll">{children}</div>
      )}
    </div>
  );
};

export default DataTable;
